const initWidjet = () => {
  const widget = document.querySelector("[data-widget]");
  if (!widget) return;
    
  const trackScroll = () => {
    window.scrollY > 300
      ? widget.style.opacity = "1"
      : widget.style.opacity = "0";
  };
  
  trackScroll();
  window.addEventListener("scroll", trackScroll);
};

export default initWidjet;
